export default "__VITE_ASSET__3c35e670__"